import styled from 'styled-components';

import { useCustomTheme } from '../../styles';


const Root = styled.fieldset`
	position: relative;
	display: inline-block;
	width: auto;
	height: auto;

	${(p) => `
		& .MuiRadio-colorPrimary:not(.Mui-disabled).Mui-checked {
			color: ${useCustomTheme(p)[0].color.accentPrimaryPressed};
		}
	`}
`;

const LabelLayout = styled.div`

	& .MuiFormLabel-root.Mui-focused {
		color: #8c8c8c;
	}

	& .MuiInputLabel-formControl {
		position: relative;
	}
`;

export {
	Root,
	LabelLayout,
}